module.exports = __webpack_public_path__ + "img/34127976000141.a54f7d0c.png";